import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
} from '@angular/core';
import { DprConsumableReport } from '@report/models';
import { StaticMessage } from '@shared/enums';
import { DprConsumable } from '@shared/models/dpr';
import {
  Consumable,
  SubprojectConfiguration,
} from '@shared/models/project-setup';

@Component({
  selector: 'app-report-consumables',
  templateUrl: './report-consumables.component.html',
  styleUrls: ['./report-consumables.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportConsumablesComponent implements OnInit {
  @Input({ required: true }) consumableList: Consumable[];
  @Input({ required: true }) dprConsumable: DprConsumable;
  @Input({ required: true }) subprojectConfiguration: SubprojectConfiguration;

  consumableReport: DprConsumableReport[] = [];

  consumableColName = $localize`:@@report.reportConsumables.colConsumable:Consumable`;
  unitsColName = $localize`:@@report.reportConsumables.colUnits:Units`;

  StaticMessage = StaticMessage;

  ngOnInit(): void {
    this.consumableList.forEach((consumable) => {
      const detail = (this.dprConsumable.dprConsumableDetails || []).find(
        (x) => x.consumableId === consumable.id
      );

      this.consumableReport.push({
        name: consumable.name,
        units: consumable.units,
        previous: detail.previous,
        today: detail.today ?? '-',
        total: (detail.previous + (detail.today ?? 0)).toFixed(2),
        added: detail.added?.toFixed(2) ?? '-',
        used: detail.used?.toFixed(2) ?? '-',
        comment: detail.comment ?? '-',
        dailyStockDetails: detail.dailyStockDetails ?? {},
      });
    });
  }
}
